import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../constants/api';
import { CURRENT_DATE } from '../constants';
import '../css/modal.css';
import '../css/autocomplete.css';
import { decodeToken } from '../utils/TokenUtils';
import { useTranslation } from 'react-i18next';
const ModalForm = ({ userId, token, route, isOpen, onRequestClose }) => {
  const { t } = useTranslation();

  const [link, setLink] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [values, setValues] = useState([]);
  const [initialValues, setInitialValues] = useState([]);

  const [message, setMessage] = useState([]);
  const [queries, setQueries] = useState('');

  const branchId = decodeToken(token, 'branch_id');
  const userlevel = decodeToken(token, 'userLevel');

  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/createform/${route}`;
    //console.log('url:', url);
    const fetchForm = async () => {
      const initialState = {};
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        setLink(response.data.link);

        setInputs(response.data.inputs);
        console.log('response.data.inputs:', response.data.inputs);

        initialState['clearAfterSubmit'] = true;

        //Loop through form inputs and create initial key values form inputs
        response.data.inputs.map((input) => {
          if (input.type === 'file') {
            initialState[input.name] = null;
          } else if (input.type === 'hidden-user') {
            initialState[input.name] = userId;
          } else if (input.type === 'hidden-branch') {
            initialState[input.name] = branchId;
          } else if (
            input.type === 'date' ||
            input.name === 'date' ||
            input.type === 'today-date'
          ) {
            initialState[input.name] = CURRENT_DATE;
          } else if (
            input.type === 'dropdown' ||
            input.type === 'load-dropdown' ||
            input.type === 'enum-dropdown' ||
            input.type === 'group-dropdown'
          ) {
            // You can determine the selected value from the data
            const selectedOption = input?.dynamic_options?.find(
              (option) => option.selected === 'selected'
            );
            if (selectedOption) {
              initialState[input.name] = selectedOption.value;
            } else if (input.value) {
              initialState[input.name] = input.value;
            } else {
              initialState[input.name] = '';
            }
          } else {
            initialState[input.name] = input.value
              ? String(input.value).trim()
              : '';
          }
        });

        setValues(initialState);
        setInitialValues(initialState);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLink([]);
        setInputs([]);
        setLoading(false);
      }
    };

    fetchForm();
  }, [route]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    //console.log(name, value, type, checked );
    setValues((prevValues) => ({
      ...prevValues,
      // [name]: value,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleLoadDropdownChange = async (e, input) => {
    const { name, value, type, checked } = e.target;
    const inputId = input.id;
    const inputName = input.name;
    const loadInputName = input.load_input_name;
    // check if load-dropdowns does not have load-input-name and stop loading
    if (!input.load_input_name) {
      setLoading(false);
      return;
    }
    //  console.log('input:', input);

    //console.log(name, value, type, checked );
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    try {
      setLoading(true);
      const url = `${API_URL}/${ENDPOINTS.SYS}/load-dropdown/${inputId}/${value}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });

      // console.log('url:', url, 'response:', response.data);
      //setSuggestions(response.data); // Update suggestions from server response
      // console.log('input:', input);
      setInputs((prevInputs) =>
        prevInputs.map(
          (input) =>
            input.name === loadInputName
              ? { ...input, dynamic_options: response.data.results } // Update the dynamic_options
              : input // Keep other inputs unchanged
        )
      );
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAutocompleteChange = (e, inputId) => {
    const { name, value, type, checked } = e.target;

    setQueries((prev) => ({ ...prev, [inputId]: value }));

    //setInputId(inputId);
    // setQuery(value);

    fetchSuggestions(value, inputId);
  };

  // Function to fetch suggestions from the server
  const fetchSuggestions = async (query, inputId) => {
    if (!query) {
      setSuggestions((prev) => ({ ...prev, [inputId]: [] }));
      return;
    }
    try {
      setLoading(true);
      const url = `${API_URL}/${ENDPOINTS.SYS}/autocomplete/${inputId}?query=${query}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });

      // console.log('url:', url, 'response:', response.data);
      // setSuggestions(response.data); // Update suggestions from server response
      setSuggestions((prev) => ({ ...prev, [inputId]: response.data }));
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSetClickedValue = (input, suggestion) => {
    //console.log(name, value, type, checked );
    setValues((prevValues) => ({
      ...prevValues,
      [input.name]: suggestion.id,
    }));
    // setQuery(suggestion.name);

    setQueries((prev) => ({ ...prev, [input.id]: suggestion.name }));
    setSuggestions((prev) => ({ ...prev, [input.id]: [] }));
  };

  // Handle file input changes dynamically
  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0]; // Get the selected file

    setValues((prev) => ({
      ...prev,
      [name]: file, // Dynamically set the file input field by name
    }));
  };

  //console.log('insert route:', `${API_URL}/${ENDPOINTS.SYS}/create/${route}`)

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Create a copy of formData without the clearAfterSubmit field
    const { clearAfterSubmit, ...values2 } = values;

    try {
      const route2 = route.replace(/^\s+|\s+$/g, ''); // Trims leading and trailing spaces
      //  console.log('route: "', route, '", route2: "', route2, '"');
      var insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/${route}`;
      if (
        link.api_route &&
        link.api_route !== '' &&
        link.api_route.trim() !== ''
      ) {
        insertUrl = `${API_URL}/${link.api_route}`;
        // link.form_type = 'reg-upload-modal'; // to send to upload for test only
      } else if (
        link.form_type === 'reg-upload-modal' &&
        link.sql_query &&
        link.sql_query.trim() !== ''
      ) {
        insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create-upload-custom/${route}`;
      } else if (link.form_type === 'reg-upload-modal') {
        insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create-upload/${route}`;
      }
      //   console.log('insert route:', insertUrl, 'values:', values);

      const data = new FormData();

      // Append all fields (including files) to FormData
      Object.keys(values2).forEach((key) => {
        data.append(key, values2[key]); // Appends both files and text fields dynamically
      });
      try {
        console.log('values2:', values2);
        var response;
        if (link.form_type === 'reg-upload-modal') {
          // console.log('data:', data.entries());

          response = await axios.post(insertUrl, data, {
            headers: {
              'Content-Type': 'multipart/form-data', // Required for FormData
              Authorization: token ? `Bearer ${token}` : '',
            },
          });
        } else {
          response = await axios.post(insertUrl, values2, {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          });
        }
        // print console url, request and response

        if (userlevel === 'developer') {
          console.log(
            'url:',
            insertUrl,
            'request:',
            values2,
            'reponse:',
            response.data
          );
        }
        setMessage(response.data);
        if (response.data.success === '1' || response.data.success === 1) {
          // Clear form only if checkbox is checked
          if (clearAfterSubmit) {
            setValues(initialValues);
          }
        }

        // onRequestClose(); // Close modal after submission
      } catch (error) {
        alert(`An error occurred ${error.message}`);
        // console.log('error:', error, 'insertUrl:',insertUrl, 'values:', values);
      }
    } catch (error) {
      alert(`An error occurred ${error.message}`);
    }
  };

  // console.log('link:', link);
  // console.log('inputs:', inputs);
  //console.log('message:', message);

  return (
    <div
      className={`modal fade ${isOpen ? 'show' : ''}`}
      style={{ display: isOpen ? 'block' : 'none' }}
      tabIndex="-1"
      aria-hidden={isOpen ? 'false' : 'true'}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content  ">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">
              {link?.name}
              <small>
                {' '}
                {link?.category} - {link?.sub_category}
              </small>
            </h5>

            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onRequestClose}
            ></button>
          </div>
          <div className="modal-body  ">
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="row">
                {inputs &&
                  inputs.map((input) => {
                    const options =
                      input.options
                        ?.split(',')
                        .map((option) => option.trim()) || [];

                    return (
                      <div
                        className={`mb-3 col-${input.size} ${input.type.includes('hidden') ? 'd-none' : ''}`}
                        key={input.name}
                      >
                        {input.type !== 'hidden-user' &&
                          input.type !== 'hidden' &&
                          input.type !== 'hidden-branch' && (
                            <>
                              <label
                                htmlFor={input.name}
                                className="form-label text-capitalize font-weight-bold text-start"
                                style={{ textAlign: 'left !important' }}
                              >
                                {/* {input.label}:{' '} */}
                                {t(input.label)}:{' '}
                                {input.is_required !== 0 && (
                                  <>
                                    <span
                                      className="text-danger"
                                      title={`'${input.label}' field is required, please fill it before submit the form`}
                                    >
                                      {' '}
                                      *
                                    </span>
                                    {input.description && (
                                      <span
                                        className=""
                                        style={{
                                          backgroundColor: 'red',
                                          color: 'white',
                                          borderRadius: '30%',
                                        }}
                                        title={`${input.description} ${input.help}`}
                                      >
                                        ?
                                      </span>
                                    )}
                                  </>
                                )}
                              </label>{' '}
                              &nbsp;&nbsp;
                            </>
                          )}
                        {(() => {
                          switch (input.type) {
                            case 'radio':
                              return (
                                input.dynamic_options &&
                                input.dynamic_options.map((option, index) => (
                                  <div
                                    className="form-check form-check-inline"
                                    key={index}
                                  >
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      id={`${input.name}-${index}`}
                                      name={input.name}
                                      value={option.id}
                                      checked={values[input.name] === option.id}
                                      onChange={handleChange}
                                    />
                                    <label
                                      htmlFor={`${input.name}-${index}`}
                                      className="form-check-label"
                                    >
                                      {option.name}
                                    </label>
                                  </div>
                                ))
                              );

                            case 'dropdown':
                              return (
                                <select
                                  className="form-select"
                                  id={input.name}
                                  name={input.name}
                                  value={values[input.name]}
                                  onChange={handleChange}
                                  required={input.is_required}
                                >
                                  <option value="" disabled>
                                    Select an option
                                  </option>

                                  {input.dynamic_options &&
                                    input.dynamic_options.map(
                                      (option, index) => {
                                        // Get the keys of the option object
                                        const optionKeys = Object.keys(option);

                                        // Access the first and second key values (fallback to default if less than 2 keys exist)
                                        const firstValue =
                                          option[optionKeys[0]] || 'No Value 1';
                                        const secondValue =
                                          option[optionKeys[1]] || 'No Value 2';

                                        return (
                                          <option
                                            key={index}
                                            value={firstValue}
                                          >
                                            {secondValue}
                                          </option>
                                        );
                                      }
                                    )}
                                </select>
                              );
                            case 'group-dropdown':
                              return (
                                <select
                                  className="form-select"
                                  id={input.name}
                                  name={input.name}
                                  value={values[input.name]}
                                  onChange={handleChange}
                                  required={input.is_required}
                                >
                                  <option value="" disabled>
                                    Select an option
                                  </option>
                                  {input.dynamic_options &&
                                    Object.entries(
                                      input.dynamic_options.reduce(
                                        (groups, option) => {
                                          // Group options by the 'group' key
                                          if (!groups[option.group])
                                            groups[option.group] = [];
                                          groups[option.group].push(option);
                                          return groups;
                                        },
                                        {}
                                      )
                                    ).map(([group, options]) => (
                                      <optgroup key={group} label={group}>
                                        {options.map((option) => (
                                          <option
                                            key={option.id}
                                            value={option.id}
                                          >
                                            {option.name}
                                          </option>
                                        ))}
                                      </optgroup>
                                    ))}
                                </select>
                              );

                            case 'load-dropdown':
                              return (
                                <select
                                  className="form-select"
                                  id={input.name}
                                  name={input.name}
                                  value={values[input.name]}
                                  onChange={(e) =>
                                    handleLoadDropdownChange(e, input)
                                  }
                                  required={input.is_required}
                                >
                                  <option value="%">Select all</option>
                                  {input.dynamic_options?.map(
                                    (option, index) => (
                                      <option key={index} value={option.id}>
                                        {option.name}
                                      </option>
                                    )
                                  )}
                                </select>
                              );

                            case 'autocomplete':
                              return (
                                <div className="position-relative">
                                  <input
                                    type="text"
                                    className="form-control" // Bootstrap class for styling
                                    // value={query}
                                    value={queries[input.id] || ''}
                                    onChange={(e) =>
                                      handleAutocompleteChange(e, input.id)
                                    }
                                    placeholder="Search..."
                                    style={{
                                      width: '100%', // Ensure it matches the container width
                                    }}
                                  />
                                  {loading && <div>Loading...</div>}
                                  {suggestions[input.id]?.length > 0 && (
                                    <ul
                                      className="list-group position-absolute"
                                      style={{
                                        margin: 0,
                                        top: '100%',
                                        width: '100%',
                                        zIndex: 1,
                                        maxHeight: '200px', // Limit height
                                        overflowY: 'auto', // Add vertical scroll
                                        border: '1px solid #ccc', // Add border for better visibility
                                        borderRadius: '4px',
                                        backgroundColor: '#fff',
                                      }}
                                    >
                                      {suggestions[input.id].map(
                                        (suggestion, index) => (
                                          <li
                                            className="list-group-item"
                                            key={index}
                                            onClick={() => {
                                              handleSetClickedValue(
                                                input,
                                                suggestion
                                              ); // Set clicked suggestion as the query
                                              //   setSuggestions([]); // Clear suggestions after selection
                                            }}
                                            style={{
                                              padding: '8px',
                                              cursor: 'pointer',
                                            }}
                                          >
                                            {suggestion.name}
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  )}
                                  <p className="text-danger">
                                    {input?.loadInfo}
                                  </p>
                                </div>
                              );

                            case 'enum':
                              return (
                                options &&
                                options.map((option, index) => (
                                  <div
                                    className="form-check form-check-inline"
                                    key={index}
                                  >
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      id={`${input.name}-${index}`}
                                      name={input.name}
                                      value={option}
                                      checked={values[input.name] === option}
                                      onChange={handleChange}
                                    />
                                    <label
                                      htmlFor={`${input.name}-${index}`}
                                      className="form-check-label"
                                    >
                                      {option}
                                    </label>
                                  </div>
                                ))
                              );
                            case 'enum-checkbox':
                              return options?.map((option, index) => (
                                <div className="form-check" key={index}>
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`${input.name}-${index}`}
                                    name={input.name}
                                    value={option}
                                    checked={values[input.name]?.includes(
                                      option
                                    )}
                                    onChange={(e) => {
                                      const isChecked = e.target.checked;
                                      const currentValues =
                                        values[input.name] || [];
                                      const updatedValues = isChecked
                                        ? [...currentValues, option]
                                        : currentValues.filter(
                                            (val) => val !== option
                                          );

                                      handleChange({
                                        target: {
                                          name: input.name,
                                          value: updatedValues,
                                        },
                                      });
                                    }}
                                  />
                                  <label
                                    htmlFor={`${input.name}-${index}`}
                                    className="form-check-label"
                                  >
                                    {option}
                                  </label>
                                </div>
                              ));

                            case 'enum-dropdown':
                              return (
                                <select
                                  className="form-select"
                                  id={input.name}
                                  name={input.name}
                                  value={values[input.name]}
                                  onChange={handleChange}
                                  required={input.is_required}
                                >
                                  <option value="" disabled>
                                    Select an option
                                  </option>
                                  {options &&
                                    options.map((option, index) => (
                                      <option key={index} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                </select>
                              );

                            case 'checkbox':
                              return (
                                input.dynamic_options &&
                                input.dynamic_options.map((option, index) => (
                                  <div
                                    className="form-check form-check-inline"
                                    key={index}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`${input.name}-${index}`}
                                      name={input.name}
                                      value={option.id}
                                      checked={values[input.name]?.includes(
                                        option.id
                                      )}
                                      onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        const value = option.id;
                                        const currentValues =
                                          values[input.name] || [];
                                        const updatedValues = isChecked
                                          ? [...currentValues, value]
                                          : currentValues.filter(
                                              (v) => v !== value
                                            );
                                        handleChange({
                                          target: {
                                            name: input.name,
                                            value: updatedValues,
                                          },
                                        });
                                      }}
                                    />
                                    <label
                                      htmlFor={`${input.name}-${index}`}
                                      className="form-check-label"
                                    >
                                      {option.name}
                                    </label>
                                  </div>
                                ))
                              );

                            case 'hidden-user':
                              return (
                                <input
                                  type="hidden"
                                  id={input.name}
                                  name={input.name}
                                  value="0"
                                  required={input.is_required}
                                />
                              );
                            case 'hidden-branch':
                              return (
                                <input
                                  type="hidden"
                                  id={input.name}
                                  name={input.name}
                                  value="0"
                                  required={input.is_required}
                                />
                              );

                            case 'textarea':
                              return (
                                <textarea
                                  className="form-control"
                                  id={input.name}
                                  name={input.name}
                                  rows="3"
                                  value={values[input.name]}
                                  onChange={handleChange}
                                  required={input.is_required}
                                ></textarea>
                              );
                            case 'file':
                              return (
                                <>
                                  <input
                                    title="file"
                                    type={input.type}
                                    className="form-control"
                                    id={input.name}
                                    name={input.name}
                                    placeholder={input.placeholder}
                                    onChange={handleFileChange}
                                    required={input.is_required}
                                    accept={input.allowed_extensions} // Restricts file type selection in the browser
                                  />
                                  <p className="text-danger">
                                    Only allowed files: '
                                    {input.allowed_extensions}', Max size:{' '}
                                    {input.max_size_mb}MB
                                  </p>
                                </>
                              );
                            case 'today-date':
                              return (
                                <>
                                  <input
                                    title="Today date, can't change the date"
                                    type={input.type}
                                    className="form-control"
                                    id={input.name}
                                    name={input.name}
                                    placeholder={input.placeholder}
                                    value={values[input.name]}
                                    onChange={handleChange}
                                    required={input.is_required}
                                    readOnly
                                  />
                                </>
                              );
                            default:
                              return (
                                <>
                                  <input
                                    type={input.type}
                                    className="form-control"
                                    id={input.name}
                                    name={input.name}
                                    placeholder={input.placeholder}
                                    value={values[input.name]}
                                    onChange={handleChange}
                                    required={input.is_required}
                                    readOnly={input.is_readonly} // Conditionally apply readOnly
                                  />
                                </>
                              );
                          }
                        })()}
                      </div>
                    );
                  })}
                <div className="d-flex justify-content-end align-items-center">
                  <label className="form-check-label fs-4">
                    <input
                      type="checkbox"
                      name="clearAfterSubmit"
                      checked={values.clearAfterSubmit}
                      onChange={handleChange}
                      className="form-check-input form-check-lg"
                    />
                    &nbsp;Clear after submit
                  </label>
                </div>

                <button type="submit" className="btn btn-primary">
                  {link.button && link.button}
                  {!link.button && 'Submit'}
                </button>
                {/* <button
                  type="button"
                  className="btn btn-secondary ms-2"
                  onClick={onRequestClose}
                >
                  Close
                </button> */}
                {(message.success === 0 || message.success === '0') && (
                  <div className="alert alert-danger" role="alert">
                    {message.message}
                  </div>
                )}
                {(message.success === 1 || message.success === '1') && (
                  <div className="alert alert-success" role="alert">
                    {message.message}
                    {message.insertId && link.print_route && (
                      <a
                        href={`/invoice/${link.print_route}/${message.insertId}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        &nbsp;Print
                      </a>
                    )}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalForm;
